import { render, staticRenderFns } from "./TurnPrompt.vue?vue&type=template&id=2d4770d0&scoped=true"
import script from "./TurnPrompt.vue?vue&type=script&lang=ts"
export * from "./TurnPrompt.vue?vue&type=script&lang=ts"
import style0 from "./TurnPrompt.vue?vue&type=style&index=0&id=2d4770d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4770d0",
  null
  
)

export default component.exports